var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"min-height":"80px"}},[_c('audio',{staticStyle:{"display":"block"},attrs:{"controls":"","src":_vm.audioURL}})])}
var staticRenderFns = []

export { render, staticRenderFns }